var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SingleNumberFrame',{attrs:{"title":"Tablet","value":_vm.itemData + ' %'},scopedSlots:_vm._u([{key:"icon",fn:function(){return [(_vm.iconColor === 'blue')?_c('icon-blue'):_vm._e(),(_vm.iconColor === 'white')?_c('icon-white'):_vm._e()]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }